import React, { useState, useEffect } from 'react';
import Module from 'components/modules';
import getContainerSizeClass from "@root/helpers/get-container-size-class";


const AccordionBlock = ({
    data,
    items: itemsProp,
    title: titleProp,
    style: styleProp,
    opnedIndex: opnedIndexProp,
    moduleSettings: moduleSettingsProp,
    className,
}) => {
    const isSanityMode = Boolean(data);

    const resolvedTitle = isSanityMode ? data?.title : titleProp;
    const resolvedStyle = isSanityMode ? data?.style : styleProp;
    const resolvedOpnedIndex = isSanityMode ? data?.opnedIndex : opnedIndexProp;
    const resolvedItems = isSanityMode ? data?.items : itemsProp;
    const resolvedModuleSettings = isSanityMode ? data?.moduleSettings : moduleSettingsProp;

    const [activeIndex, setActiveIndex] = useState(null);

    useEffect(() => {
        if (resolvedOpnedIndex !== undefined && resolvedOpnedIndex !== null) {
            const initialIndex = Number(resolvedOpnedIndex);
            if (!isNaN(initialIndex) && initialIndex >= 0 && resolvedItems && initialIndex < resolvedItems.length) {
                setActiveIndex(initialIndex);
            }
        }
    }, [resolvedOpnedIndex, resolvedItems]);

    const style = resolvedStyle || "default";

    const getStyleClass = () => {
        const stylesList = {
            default: "accordion-block--default",
            hollow: "accordion-block--hollow",
        };
        return stylesList[style] || stylesList.default;
    };

    const handleToggle = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const classes = getContainerSizeClass(resolvedModuleSettings);

    return (
        <div className={`accordion-block ${getStyleClass()}${className ? ` ${className}` : ''}`}>
            <div className={`accordion-block__container ${classes.join(" ")}`}>
                {resolvedTitle && (
                    <h3 className="accordion-block__title">{resolvedTitle}</h3>
                )}
                <div className="accordion-block__items">
                    {resolvedItems?.map((item, index) => {
                        const isSanityItem = Boolean(item?._type);

                        if (isSanityMode && !isSanityItem) return null;

                        const isOpen = activeIndex === index;
                        const key = item._key || item.id || index;

                        return (
                            <div key={key} className={`accordion-block__item ${isOpen ? 'accordion-block__item--open' : ''}`}>
                                <div
                                    className="accordion-block__item-header"
                                    onClick={() => handleToggle(index)}
                                >
                                    <p className="accordion-block__item-title">{item?.title}</p>
                                    <div className="accordion-block__item-toggle">
                                        <svg
                                            style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }}
                                            width="22" height="10" viewBox="0 0 22 10" fill="none" xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M0.999997 9L11 1L21 9" stroke="#00344E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>

                                <div className="accordion-block__item-content">
                                    <div className="accordion-block__inner-wrapper">
                                        {isSanityItem ? (
                                            (Array.isArray(item?.module) ? item.module : item?.module ? [item.module] : []).map((module) => (
                                                <Module
                                                    key={module?._key || item?.title}
                                                    type={module?._type}
                                                    moduleData={module}
                                                />
                                            ))
                                        ) : (
                                            item?.content ?? null
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default AccordionBlock;
